import diamondImage from "@/assets/diamond.png";
import cubeImage from "@/assets/cube.png";
import prismImage from "@/assets/prism.png";
import { useLanguage } from "@/contexts/LanguageContext";

const ExperienceSection = () => {
  const { t } = useLanguage();
  
  return (
    <section id="experience" className="py-24 px-6">
      <div className="container mx-auto max-w-7xl">
        <h2 className="text-4xl md:text-5xl font-black mb-8 text-center text-foreground text-glow-hover uppercase">
          {t("experience.title")}
        </h2>
        <p className="text-xl md:text-2xl text-center mb-16 text-muted-foreground/70">
          {t("experience.subtitle")}
        </p>

        <div className="grid md:grid-cols-3 gap-12">
          <div className="text-center space-y-4">
            <img
              src={diamondImage}
              alt="Wellness Brands"
              className="w-48 h-48 mx-auto object-contain animate-float animate-pulse-glow hover-lift hover-scale-sm"
            />
            <h3 className="text-xl text-muted-foreground transition-colors duration-300">{t("experience.wellness")} <span className="text-holographic animate-pulse-glow">{t("experience.wellnessBrand")}</span> {t("experience.wellnessEnd")}</h3>
          </div>

          <div className="text-center space-y-4">
            <img
              src={cubeImage}
              alt="E-commerce"
              className="w-48 h-48 mx-auto object-contain animate-spin-slow animate-pulse-glow hover-lift hover-scale-sm"
            />
            <h3 className="text-xl text-muted-foreground transition-colors duration-300">{t("experience.ecommerce")} <span className="text-holographic animate-pulse-glow">{t("experience.ecommerceGrowth")}</span> {t("experience.ecommerceEnd")}</h3>
          </div>

          <div className="text-center space-y-4">
            <img
              src={prismImage}
              alt="Hospitality"
              className="w-48 h-48 mx-auto object-contain animate-float-slow animate-pulse-glow hover-lift hover-scale-sm"
            />
            <h3 className="text-xl text-muted-foreground transition-colors duration-300">{t("experience.hospitality")} <span className="text-holographic animate-pulse-glow">{t("experience.hospitalityExp")}</span> {t("experience.hospitalityEnd")}</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
